var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rfq',[_c('div',{staticClass:"cust-motor-wrap guest-quote-page"},[_c('motor-start-page',{attrs:{"guest":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }